import { Delete } from '@mui/icons-material';
import { Checkbox, Divider, IconButton, List, ListItem, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectRTFO, setMapFeatures } from '../../reducers/rtfoSlice';
import { useSocket } from '../../context/useSocket';

const RTFOMapFeatures = ({ darkMode }) => {
  const dispatch = useDispatch();
  const rtfo = useSelector(selectRTFO);
  const currentRTFO = rtfo?.value;

  const { socket } = useSocket();
  const mapFeatures = currentRTFO?.mapFeatures || [];
  return (
    <div
      style={{
        position: 'absolute',
        bottom: 30,
        right: 10,
        width: 300,
        height: 200,
        borderRadius: 6,
        overflowY: 'auto',
        zIndex: 999,
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        backgroundColor: darkMode ? 'rgba(0,0,0,0.25)' : 'rgba(255,255,255,0.75)',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.4)',
        padding: 10
      }}
    >
      <Typography style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Features</Typography>

      <List style={{ margin: 0, padding: 0 }}>
        {mapFeatures?.map((feature, i) => {
          return (
            <ListItem key={`${feature?.name}-${i}`} style={{ margin: 0, padding: 0 }}>
              <RTFOMapFeature feature={feature} handleFeatureCheck={handleFeatureCheck} handleDeleteFeature={handleDeleteFeature} />
              <Divider style={{ margin: 4 }} />
            </ListItem>
          );
        })}
      </List>
    </div>
  );

  function handleFeatureCheck(name) {
    const newMapFeatures = JSON.parse(JSON.stringify(mapFeatures || []));
    newMapFeatures?.forEach((f, i) => {
      if (f.name === name) {
        newMapFeatures[i].isActive = !newMapFeatures[i].isActive;
      }
    });

    dispatch(setMapFeatures(newMapFeatures));

    // // update feature in the db
    // socket?.readyState === 1 &&
    // socket.send(JSON.stringify({
    //   messageType: 'setMapFeatures',
    //   padName: currentRTFO?.name,
    //   mapFeatures: newMapFeatures
    // }));
  }
  function handleDeleteFeature(name) {
    if (!name) return;

    const newMapFeatures = (mapFeatures || []).filter(f => f.name !== name);

    // update state
    dispatch(setMapFeatures(newMapFeatures));

    // delete feature from the db
    socket?.readyState === 1 &&
    socket.send(JSON.stringify({
      messageType: 'setMapFeatures',
      padName: currentRTFO?.name,
      mapFeatures: newMapFeatures
    }));
  }
};

const RTFOMapFeature = ({ feature, handleFeatureCheck, handleDeleteFeature }) => {
  return (
    <div
      style={{
        width: 300,
        height: 40,
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid lightgrey'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', overflow: 'hidden' }}>
        <Checkbox checked={feature?.isActive} style={{ color: feature?.color }} onChange={() => handleFeatureCheck(feature?.name)} />
        <Typography style={{ whiteSpace: 'no-wrap', fontSize: 14 }}>{feature?.name}</Typography>
      </div>
      <IconButton color="primary" size="small" onClick={() => handleDeleteFeature(feature?.name)}>
        <Delete color="secondary" style={{ width: 24, height: 24 }} />
      </IconButton>
    </div>
  );
};

export default RTFOMapFeatures;
